<div class="component-container">
    <div class="row row-no-gutters mb-2 mt-1">
        <div class="col-12 col-md-auto m-1 pr-4">
            <input pInputText type="text" class="p-inputtext mip-formname" placeholder="Form name"
                   [(ngModel)]="formName" [disabled]="editMode" #formNameRef="ngModel"
                   [ngClass]="{'ng-invalid ng-dirty': !editMode && formNameRef.invalid}" required>
        </div>
        <div class="col-12 col-md-1 form-check mip-smcol mx-2 align-self-center d-flex align-items-center">
            <input class="form-check-input" type="checkbox" [(ngModel)]="isEditable"
                   id="isEditable" />
            <label class="form-check-label ml-1" for="isEditable">
                Editable
            </label>
        </div>
        <div class="col-12 col-md-1 form-check mip-smcol m-1 align-self-center d-flex align-items-center"
             *ngIf="isEditable">
            <input class="form-check-input" type="checkbox" [(ngModel)]="editableOnlyByInstantiator"
                   id="editableOnlyByInstantiator" />
            <label class="form-check-label ml-1" for="editableOnlyByInstantiator">
                Form filler <br> only
            </label>
        </div>
        <div class="col-12 col-md-1 form-check mip-smcol m-1 align-self-center">
            <input class="form-check-input" type="checkbox" [(ngModel)]="mobileFriendly"
                   id="flexCheckDefault" />
            <label class="form-check-label ml-1" for="flexCheckDefault">
                Mobile form
            </label>
        </div>
        <div class="col-12 col-md-1 form-check mip-smcol m-1 align-self-center d-flex align-items-center">
            <input [disabled]="this.formDefId?.length > 0" class="form-check-input" type="checkbox"
                   [(ngModel)]="byRequestOnly"
                   id="byRequestOnly" />
            <label class="form-check-label ml-1" for="byRequestOnly">
                By request <br> only
            </label>
        </div>
        <div class="col-12 col-md-1 form-check mip-smcol m-1 align-self-center d-flex align-items-center">
            <input class="form-check-input" type="checkbox" [(ngModel)]="shareOnComplete"
                   id="shareWhenComplete" />
            <label class="form-check-label ml-1" for="shareWhenComplete">
                Share on complete
            </label>
        </div>
        <div class="col-12 col-md-2 form-dd">
            <p-dropdown *ngIf="categories"
                        [(ngModel)]="selectedCategory"
                        [disabled]="editMode"
                        [options]="categories"
                        placeholder="Select a Category"
                        optionLabel="label"
                        optionValue="value"
                        #categoriesRef="ngModel"
                        [ngClass]="{'ng-invalid ng-dirty': !editMode && categoriesRef.invalid}"
                        required>
            </p-dropdown>
        </div>
        <div class="col-12 col-md-2 form-dd">
            <p-floatLabel style="width: 100%;">
                <p-dropdown [(ngModel)]="selectedPdfExportMode"
                            id="pdfExportMode"
                            [options]="pdfExportModes"                            
                            placeholder="Select Custom PDF">
                </p-dropdown>
                <label for="pdfExportMode">Form Output</label>
            </p-floatLabel>
        </div>
        <div *ngIf="selectedPdfExportMode === FormPdfExportMode.CustomPDF && exportReports" class="col-12 col-md-2 form-dd">
            <p-floatLabel style="width: 100%;">
                <p-dropdown [filter]="true"
                            [filterBy]="'label'"
                            [showClear]="true"
                            id="linkedDashboardId"
                            required
                            #linkedDashboardIdRef="ngModel"
                            [ngClass]="{'ng-invalid ng-dirty': linkedDashboardIdRef.invalid}"
                            [(ngModel)]="selectedLinkedDashboardId"
                            [options]="exportReports"
                            placeholder="Custom PDF"
                            title="Report used for PDF export of form instances"
                            optionLabel="label"
                            optionValue="value"></p-dropdown>
                <label for="linkedDashboardId">Custom PDF</label>
            </p-floatLabel>
        </div>
        <div class="col-12 col-md-2">
            <button type="button" class="p-button m-button-primary" (click)="saveForm()"
                    [disabled]="!formValidForSaving() || isSaving">
                Save form
            </button>
            <button type="button" class="p-button p-button-secondary ml-2" (click)="clearForm()">Clear form</button>
        </div>
    </div>
    <h5 *ngIf="status" class="text-error mt-2">{{ status }}</h5>

    <h2 class="mip-formtitle">Form builder editor{{ editMode ? " - Edit Mode" : "" }}</h2>

    <episode-header-title-v3 [episode]="episode" [showActionButton]=" !oldEpisode " (click)="onClickEpisodeTitle()"
                             (delete)="deleteEpisode()" (edit)="editEpisode()"
                             style="width:100%"></episode-header-title-v3>
    <div class="form-check mb-4 ml-2">
        <input [disabled]="!!oldEpisode" class="form-check-input " type="checkbox" [(ngModel)]="episodeLock"
               id="EpisodeLock"/>
        <label class="form-check-label" for="EpisodeLock">
            Episode Lock
        </label>
    </div>

    <form-builder [form]="form" [options]="options" (change)="changeEvent($event)"></form-builder>

    <h5 *ngIf="status" class="text-error mt-2">{{ status }}</h5>

    <h5 *ngIf="formStatus">{{ formStatus }}</h5>
    <div *ngIf="editMode" class="mt-5">
        <div>
            <h3 class="text-danger"> Revision Note</h3>
        </div>
        <div>
            <textarea style="width: 100%; min-height: 50px;" pInputTextarea [(ngModel)]="revisionNote"></textarea>
            <label class="text-info text-muted">Describe the changes made to this revision.</label>
        </div>
    </div>
</div>

<!-- display error if the form definition load fails -->
<div class="card" *ngIf="errorWhileLoadingForm">
    <h4 class="mt-2 text-center text-danger">Form definition's load failed. Please close the tab. </h4>
    <h5 class="mt-2 text-center text-danger">
        Note: To create a new form design please head to FormIO Designs -> New Design
    </h5>
</div>
<hr/>
<h3 class=" text-center text-muted">Form Definition JSON Schema</h3>
<div class="well jsonviewer">
    <pre id="json"><code class="language-json" #json></code></pre>
</div>

<!--TODO: better to move these data versioning management to component-->
<p-dialog [(visible)]="displayFormVersionChangesDialog"
          [modal]="true"
          header="Confirm Form Version Data Changes">
    <bb-form-version-handler [formHasData]="formHasData"></bb-form-version-handler>
    <p-footer>
        <button pButton label="Cancel" class="p-button-secondary"
                (click)="displayFormVersionChangesDialog = false"></button>
        <button pButton label="Apply"
                (click)="displayFormSavingDialog = true"></button>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="displayFormSavingDialog">
    <h3>Is this a breaking change?</h3>
    <p-footer>
        <p-button styleClass="p-button-secondary"
                  icon="pi pi-times"
                  label="No"
                  (onClick)="saveFormChanges(false)">
        </p-button>

        <p-button icon="pi pi-check"
                  label="Yes"
                  (onClick)="saveFormChanges(true)">
        </p-button>
    </p-footer>
</p-dialog>

<episode-dialog
    *ngIf="displayAddEpisodeDialog"
    [(visible)]="displayAddEpisodeDialog"
    [isPrescription]="true"
    [showCheckBoxes]="false"
    [modal]="true"
    [patientId]="patientId"
    (onCancel)="cancelAddEpisode()"
    [assignedClinicianId]="assignedClinicianId"
    (episodeCreated)="closeAddEpisodeDialog($event)"
    [createFrom]="createFrom">
</episode-dialog>

<episode-dialog
    *ngIf="displayEditEpisodeDialog"
    [modal]="true"
    [(visible)]="displayEditEpisodeDialog"
    [episodeId]="episodeId"
    [draftedEpisode]="episode"
    [isPrescription]="true"
    [showCheckBoxes]="false"
    [createFrom]="createFrom"
    [assignedClinicianId]="assignedClinicianId"
    (episodeCreated)="closeEditEpisodeDialog($event)"
    (episodeUpdated)="closeEditEpisodeDialog($event)"
    (onCancel)="cancelEditEpisode()">
</episode-dialog>

<formio-select-patient-dialog *ngIf="displaySelectPatientDialog"
                              (onOk)="onOkSelectedPatientDialog($event)"
                              (onCancel)="displaySelectPatientDialog = false">
</formio-select-patient-dialog>